import { Box, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { convert1DArrayTo2DArray } from "../../../helpers/convert1DArrayTo2DArray";
import { RootState } from "../../../redux/store";
import { slideBasedOnMarginLeft, slideBasedOnMarginRight, fadeIn, scaleUP, transitionCubicBezier } from "../../../shared/animations";
import { ISchoolPageInfoDisplayBox, SchoolPageInfoDisplayBoxDesBox } from "../components";
import styles from '../index.module.scss';


export const NewSchoolPageInfoDisplayBox = ({
    loadedAnimation,
    title,
    description,
    leftTopBgImg,
    leftTopBgImgAlt,
    leftBottomBgImg,
    leftBottomBgImgAlt,
    deviceImg,
    deviceImgAlt,
    contents,
    rowDirectionReversed,
    underScoreColor,
    desBoxBgColor,
  }: ISchoolPageInfoDisplayBox) => {
    const screenType = useSelector((state: RootState) => state.ui.screenType);
    const slideInAnimation = rowDirectionReversed
      ? slideBasedOnMarginLeft(loadedAnimation, "0px", "-200px")
      : slideBasedOnMarginRight(loadedAnimation, "0px", "-200px");
  
    return (
      <Stack className={`flex_row_center`}>
        <Stack className={`${styles.sc_container}`}>
          <Stack className={styles.vicTitleContainer}>
            <Box
              className={`heading1 ${styles.vicH1}`}
              sx={{
                ...fadeIn(loadedAnimation),
                ...scaleUP(loadedAnimation),
                ...transitionCubicBezier,
              }}
            >
              {title}
            </Box>
            <Box
              className={`paragraph2 ${styles.vicP}`}
              sx={{
                ...fadeIn(loadedAnimation),
                ...scaleUP(loadedAnimation),
                ...transitionCubicBezier,
              }}
            >
              {description}
            </Box>
  
          </Stack>
          <Stack
            className={styles.sc_bottomStack}
            direction={
              screenType === "MOBILE"
                ? "column"
                : rowDirectionReversed
                  ? "row-reverse"
                  : "row"
            }
            alignItems='center'
            justifyContent='space-between'
          >
            <Box className={styles.sc_imgWrapper}>
              <img
                src={leftBottomBgImg}
                alt={leftBottomBgImgAlt}
                className={styles.sp_sc_bg_pink}
              />
              <img
                src={leftTopBgImg}
                alt={leftTopBgImgAlt}
                className={styles.sp_sc_bg_yellow}
              />
              <img
                src={deviceImg}
                alt={deviceImgAlt}
                className={styles.sp_sc_device}
              />
            </Box>
            <Stack
              className={styles.SchoolPageInfoDisplayBox_contentStack}
              direction={"column"}
            >
              {screenType === "MOBILE"
                ? convert1DArrayTo2DArray(contents, 2).map((contentArr) => (
                  <Stack
                    className={styles.SchoolPageInfoDisplayBox_contentRow}
                    direction={"row"}
                  >
                    {contentArr.map((config) => (
                      <SchoolPageInfoDisplayBoxDesBox
                        key={config.title}
                        {...config}
                        underScoreColor={underScoreColor}
                        desBoxBgColor={desBoxBgColor}
                      />
                    ))}
                  </Stack>
                ))
                : contents.map((config, index) => (
                  <div
                    key={config.title}
                    style={{
                      ...slideInAnimation,
                      ...slideBasedOnMarginLeft(
                        loadedAnimation,
                        "0px",
                        "-200px"
                      ),
                      transitionDelay: `${(index - 1) * 0.3}s`,
                    }}
                  >
                    <SchoolPageInfoDisplayBoxDesBox
                      {...config}
                      underScoreColor={underScoreColor}
                      desBoxBgColor={desBoxBgColor}
                    />
                  </div>
                ))}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    );
  };